export default {
  "header": {
    "logout": "Logout",
    "profile": "Edit Profile",
    "admin": "Admin",
    "onboard": "Onboard Again"
  },
  "onboarding": {
    "title": "Welcome",
    "next": "Next",
    "previous": "Previous",
    "finish": "Finish",
    "welcome": {
      "title": "Welcome to Grow With Us!"
    },
    "terms": {
      "title": "Terms & Conditions",
      "description": "Please read and accept Terms & Conditions.",
      "body": "<p>This website is intended to provide resources and activities for personal growth. Everything contained within is entirely optional, and should not be required or used as job training. This website is for the express purpose of helping individuals develop themselves, and frequency of use is determined by each individual on their own time.</p>",
      "accept": "Accept"
    },
    "complete": {
      "imgAlt": "All done with onboarding",
      "title": "You are All Done!"
    }
  },
  "home": {
    "hero": {
      "text": "Create <br/> your future.<br/><br /><br/>",
      "play": "PLAY VIDEO"
    },
    "takeCareChampion": "FOR TAKECARE CHAMPIONS",
    "activation": {
      "title": "ACTIVATION",
      "descriptionHtml": "As a <b>property leader</b> or <b>TakeCare Champion</b>, you are entrusted to guide associates on this journey and inspire their growth. We have created resources to help.",
      "action": "LEARN MORE"
    },
    "coaching": {
      "title": "COACHING",
      "descriptionHtml": "Coaching helps get associates from where they are today to where they want to be in the future.",
      "action": "LEARN MORE"
    },
    "pathway": {
      "section": {
        "learningHowToLearn": {
          "title": "Learning how to learn.",
          "description": "Start here to understand the skills and mindsets required for growth and continuous, lifelong learning"
        },
        "mindfulness": {
          "title": "Get your mind ready.",
          "description": "Learn how to bring <b>focus</b> to your life, improve your mental and physical well-being, and become more aware and relaxed."
        },
        "resilience": {
          "title": "Are you up for the challenge?",
          "description": "Learn how to <b>recharge</b>, remain positive and proactive, act and think in a balanced way, and empathize with others."
        },
        "grow": {
          "title": "Keep Growing.",
          "description": "This collection of pathways is designed to help you achieve a sense of <b>Wellbeing</b>, accelerate <b>Personal Development</b>, and gain <b>Professional Skills</b>."
        }
      }
    }
  },
  "pathway": {
    "back": "BACK",
    "playbook": {
      "back": "BACK",
      "focus": {
        "leadItemDescription": "Start here to understand the skills and mindsets required for growth and continuous, lifelong learning.",
        "itemsTitle": "TRY THIS!",
        "itemsDescription": "These activites help you let go of daily stresses, feel more relaxed, and concerntrate on what is more important. Check back!",
      },
      "recharge": {
        "leadItemDescription": "Start here to understand the skills and mindsets required for growth and continuous, lifelong learning.",
        "itemsTitle": "TRY THIS!",
        "itemsDescription": "These activites help you let go of daily stresses, feel more relaxed, and concerntrate on what is more important. Check back!",
      }
    },
    "card": {
      "count": "%{topicCount} topics, %{assetCount} assets",
      "inThisPathway": "IN THIS PATHWAY:"
    },
    "category": {
      "Wellbeing": "WELLBEING",
      "Professional Skills": "PROFESSIONAL SKILLS",
      "Personal Development": "PERSONAL DEVELOPMENT"
    }
  },
  "playbook": {
    "item": {
      "takeaway": "TAKEAWAY",
      "setting": "SETTING",
      "setup": "SET UP",
      "technique": "TECHNIQUE",
      "back": "BACK"
    }
  },
  "activation": {
    "back": "BACK",
    "title": "Activating TakeCare Grow",
    "subtitle": "Below are materials and resources to help you activate and promote TakeCare Grow at your location!",
    "descriptionHtml": "<p><b>TakeCare Grow</b> is an online platform that helps associates grow their skillsets to thrive in their career and life. Mobile-capable, TakeCare Grow gives associates access to insights, exclusive tools and video-based learning resources anytime, anywhere.</p><p>As traditional jobs change and new roles emerge, TakeCare Grow unlocks the knowledge and expertise of associates to prioritize their continuous learning and prepare them for the future of work.</p><p>Download the library of materials to help you activate TakeCare Grow at your location. Materials are editable for you to customize as needed.</p>",
    "downloadVideo": "Download Videos",
    "downloadTitle": "Downloadable Toolkit",
    "downloadSubtitle": "For Property Leaders and Champions"
  },
  "profile": {
    "title": "Edit Settings",
    "details": {
      "title": "Details"
    },
    "language": {
      "title": "Language",
      "instructions": "Please select your preferred <b>language</b>.",
      "unsupportedLanguage": "Your selected language is not available yet. Please check back soon."
    },
    "country": {
      "title": "Country",
      "instructions": "Please select your <b>country</b>."
    },
    "role": {
      "title": "TakeCare Champion or Property Leader?",
      "instructions": "Are you a TakeCare champion or a property leader?"
    }
  },
  "resource": {
    "tile": {
      "viewed": "Viewed",
      "completed": "Completed",
      "markComplete": "Mark Complete"
    },
    "types": {
      "display": {
        "resource": "Resource",
        "book": "Book",
        "video": "Video",
        "app": "App",
        "activity": "Activity",
        "article": "Article",
        "course": "Course",
        "ebook": "eBook",
        "elearning": "E-Learning App",
        "mooc": "Course",
        "podcast": "Podcast",
        "tool": "Online Tool",
        "website": "Website",
        "tool-phone": "Phone App",
        "video-activity": "Video Activity",
        "videos": "Video",
        "videos-activity": "Video Activity"
      },
      "action": {
        "book": "Read",
        "video": "Watch Video",
        "app": "Go to App",
        "activity": "Go to Activity",
        "article": "Read Article",
        "course": "Go to Course",
        "ebook": "Read eBook",
        "elearning": "Go to E-Learning App",
        "mooc": "Go to Course",
        "podcast": "Listen to Podcast",
        "tool": "Go to Tool",
        "website": "View Website",
        "tool-phone": "Go to Phone App",
        "video-activity": "Go to Video Activity",
        "videos": "Watch",
        "videos-activity": "Go to Video Activity"
      }
    }
  },
  "admin": {
    "title": "Admin",
    "rights": {
      "title": "User Privileges",
      "description": "Assign specifc users admin and/or editor privileges.",
      "back": "Back to Admin",
      "getUser": {
        "title": "First get the user",
        "label": "Type in the username of the person you want to edit",
        "button": "Submit"
      },
      "updateUser": {
        "title": "User Privilages: %{userNameDisplay}",
        "button": "Update User Privileges"
      },
      "admin": {
        "title": "Make Admin",
        "canEditTitle": "Can Edit Privileges",
        "canEditDescription": "Can edit the privileges of other users (use this page).",
        "canMakeAdminTitle": "Can Make Others Admin",
        "canMakeAdminDescription": "Can give others the ability to edit privileges."
      },
      "lang": {
        "title": "Site Language",
        "canEditAllTitle": "Can Edit All Languages",
        "canEditAllDescription": "Can make updates all available site language labels."
      }
    },
    "lang": {
      "title": "Site Language",
      "description": "Manage translations for various languages for labels that appear on this website.",
      "back": "Back to Admin",
      "new": "Add New language",
      "table": {
        "language": "Language",
        "code": "Code",
        "actions": "Actions",
        "download": "Download CSV",
        "upload": "Update"
      },
      "add": {
        "title": "Add New Site Language Translations",
        "description": "Select the language you want to add and upload a CSV file with label translations.",
        "back": "Back to Site Language Admin",
        "language": "Select Language",
        "download": "Download CSV template file to edit",
        "upload": "Upload CSV file",
        "submit": "Submit",
        "success": "Language added successfully!"
      },
      "update": {
        "title": "Update Site Language Translations",
        "description": "Description",
        "back": "Back to Site Language Admin",
        "language": "Updating Language",
        "code": "Language Code",
        "download": "Download existing CSV file to edit",
        "upload": "Upload CSV file",
        "submit": "Submit",
        "success": "Language updated successfully!"
      }
    }
  },
  "forbidden": {
    "title": "Sorry!",
    "body": "Looks like you do not have access to this page!",
    "goHome": "Go to the Home Page"
  },
  "footer": {
    "quote1": "One of my greatest joys is seeing associates grow their skills and build successful careers. OPPORTUNITY transforms lives. Creating opportunity is the most fulfilling thing we do.",
    "quoteBy1": "J.W. MARRIOTT, JR., EXECUTIVE CHAIRMAN AND CHAIRMAN OF THE BOARD"
  }
};



// WEBPACK FOOTER //
// ./src/lang/phrases_en.js